import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import Beginner from "@/pages/home/components/Beginner";
import Ranking from "@/pages/home/components/Ranking";
import Masterpiece from "@/pages/home/components/Masterpiece";
import Reviews from "@/pages/home/components/Reviews";
import Faq from "@/pages/home/components/Faq";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Beginner />
        <Ranking />
        <Masterpiece />
        <Reviews />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}